import resourceFactory from 'common/admin/resourceFactory'

const actions = resourceFactory('categories')

export default actions
